import React from 'react'
import PaperPage from 'src/components/organisms/whitepapers/PaperPage'
import thumbnail from 'src/images/whitepapers/commmune_communitymarketing_3merits.jpg'

const paperInfo = {
    paperName: 'ファンをつくるなら取り組みたい「コミュニティマーケティング」がもたらす３つのメリット',
    thumbnail,
    feature1: '継続的な売上の確保における「ファン」の重要性',
    feature2: 'ファンをつくる手段の「コミュニティマーケティング」とは',
    feature3: 'コミュニティマーケティングがもたらす３つのメリット',
    description:
        '市場の縮小と、デジタルの普及による消費者の情報収集の多様化により「ファンの創出・育成」といった中長期的な売上の拡大を狙うマーケティング施策が注目されています。そこでファンをつくるための手法として有効とされているのが「コミュニティマーケティング」です。この資料を読むことで、コミュニティマーケティングが重要視されている理由や、具体的なメリットの理解が深まります。',
    formSrc: 'https://go.commmune.jp/l/915341/2022-08-18/hx5bz',
    type: 'pardot' // TODO: HubSpotからPardotに移行したらこのタグ付けが不要になるので削除する
}

const WhitePaperPage = () => {
    return <PaperPage {...paperInfo} />
}

export default WhitePaperPage
